export function scramblePlaybackTemplate(scramble, playbackSpeed = 1) {
  const formula = scramble.moves.map((move, index) => (
    `<span class="formula-move" data-formula-step="${index + 1}">${move}</span>`
  )).join(' ');

  return `<section class="playback-layout scramble-playback-layout" aria-labelledby="scramble-playback-title">
    <div class="playback-stage-panel">
      <div class="entry-heading playback-heading">
        <button class="back-button" type="button" data-action="back-scramble-settings"><span aria-hidden="true">←</span> 重新设置</button>
        <div><p class="eyebrow">3×3 打乱执行</p><h1 id="scramble-playback-title">按照公式逐步打乱</h1></div>
      </div>
      <div class="cube-canvas playback-canvas" data-cube-canvas></div>
      <div class="stage-footer"><p><span aria-hidden="true">↻</span> 播放时仍可拖动旋转视角</p><p>完成后保留最终打乱状态</p></div>
    </div>

    <aside class="playback-panel scramble-playback-panel" aria-label="打乱公式播放控制">
      <div class="playback-summary">
        <div><p class="section-kicker">打乱进度</p><h2><span data-playback-step>0</span><small> / ${scramble.moveCount}</small></h2></div>
        <div class="solve-metric"><strong>${scramble.moveCount}</strong><span>总动作</span></div>
        <div class="solve-metric"><strong>3×3</strong><span>阶数</span></div>
      </div>

      <div class="move-focus">
        <div><span>当前动作</span><strong data-current-move>准备</strong></div>
        <div class="move-explanation"><span data-move-description>从完整复原状态开始</span><small>下一动作：<b data-next-move>${scramble.moves[0] ?? '完成'}</b></small></div>
      </div>

      <div class="formula-panel">
        <div class="section-label"><h3>WCA 格式打乱公式</h3><span>${scramble.moveCount} 步</span></div>
        <div class="formula-text" data-formula>${formula}</div>
      </div>

      <div class="transport-controls">
        <button type="button" data-action="first" aria-label="跳到第一步">|←</button>
        <button type="button" data-action="previous">上一步</button>
        <button class="play-button" type="button" data-action="play">开始动画</button>
        <button type="button" data-action="pause" hidden>暂停</button>
        <button type="button" data-action="next">下一步</button>
        <button type="button" data-action="last" aria-label="跳到最后一步">→|</button>
      </div>

      <div class="playback-options">
        <button class="secondary-button" type="button" data-action="restart"><span aria-hidden="true">↺</span> 重置</button>
        <label>播放速度
          <select data-playback-speed aria-label="播放速度">
            ${[0.1, 0.25, 0.5, 1, 1.5, 2].map((speed) => `<option value="${speed}"${Number(playbackSpeed) === speed ? ' selected' : ''}>${speed}×</option>`).join('')}
          </select>
        </label>
      </div>
      <button class="secondary-button wide playback-home" type="button" data-action="back-timer">返回计时器</button>
    </aside>
  </section>`;
}
